import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

Vue.use(Vuetify)

const opts = {}

export default new Vuetify(opts)